import { useContext } from 'react';
import { css } from '@emotion/react';
import { CreateGroupChatContext, Participants } from '~/pages/CreateGroupChat';
import * as S from '~/pages/CreateGroupChat/index.styled';
import { DefaultButton, FlexStack, Select } from '~/components/atomic';
import { Textarea } from '~/components/common';
import BottomSheetContainer from '~/components/common/BottomSheet/BottomSheet';
import Inner from '~/components/common/BottomSheet/EditName/BottomSheetInner';
import { Header } from '~/components/common/Header';
import { Language, languages } from '~/types';

export default function GenerateGroupChat() {
  const {
    chatName,
    setChatName,
    description,
    setDescription,
    participants,
    setParticipants,
    setStep,
    handleGenerateClick,
    accessibility,
    setAccessibility,
    passwordSheetOpen,
    password,
    setPassword,
    handlePrivateDoneClick,
    language,
    setLanguage,
    selectedAiCharacter,
    handlePasswordSheetClose,
    isGenerateDisabled,
  } = useContext(CreateGroupChatContext);

  return (
    <>
      <Header.Root>
        <Header.Section>
          <Header.PrevButton />
          <Header.Title>Generate Group chat</Header.Title>
        </Header.Section>
      </Header.Root>

      <S.Container>
        <S.Wrapper>
          <FlexStack>
            <S.Title>Group Chat Name</S.Title>
            <Textarea
              value={chatName}
              onChange={(e) => setChatName(e.target.value.replace('\n', ''))}
              maxLength={20}
              rows={1}
              placeholder='Group Chat name'
            />
          </FlexStack>

          <FlexStack>
            <S.Title>Chat description</S.Title>
            <Textarea
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              maxLength={75}
              rows={2}
              placeholder='About this Group chat'
            />
          </FlexStack>

          <FlexStack>
            <S.Title>Language</S.Title>
            {/* <Dropdown placeholder={language?.label || 'Language'}>
              <DropdownOptions options={Languages} onClick={setLanguage} />
            </Dropdown> */}

            <Select
              modalTitle={'Language'}
              selectedOption={language || ''}
              isPlaceholder={'Language'}
              selectOptions={languages}
              click={(option: string) => setLanguage(option as Language)}
            >
              {language}
            </Select>
          </FlexStack>

          <FlexStack>
            <S.Title>Accessibility</S.Title>
            <S.AccessibilityWrapper>
              <S.AccessibilityButton
                selected={accessibility === 'public'}
                onClick={() => setAccessibility('public')}
              >
                Public
              </S.AccessibilityButton>
              <S.AccessibilityButton
                selected={accessibility === 'private'}
                onClick={() => setAccessibility('private')}
              >
                Private
              </S.AccessibilityButton>
            </S.AccessibilityWrapper>
          </FlexStack>

          <FlexStack>
            <S.Title>Participants</S.Title>
            <FlexStack>
              <S.ParticipantsWrapper>
                <S.Description>Limit number of participants</S.Description>
                {/* <Dropdown placeholder={participants.id} width={70}>
                  <DropdownOptions
                    options={Participants}
                    onClick={setParticipants}
                  />
                </Dropdown> */}

                <Select
                  width={'100px'}
                  modalTitle={'Participants'}
                  selectedOption={participants}
                  isPlaceholder={'Participants'}
                  selectOptions={Participants}
                  click={(option: string) => setParticipants(option)}
                >
                  {participants}
                </Select>
              </S.ParticipantsWrapper>

              <S.ButtonWrapper>
                {selectedAiCharacter.length > 0 ? (
                  <DefaultButton
                    onClick={() => setStep('SetAiChatbot')}
                    colorType='black'
                    css={css`
                      justify-content: space-between;
                    `}
                  >
                    Set Ai chatbot
                    <div
                      css={css`
                        display: flex;
                        gap: 4px;
                      `}
                    >
                      {selectedAiCharacter.map((c) => (
                        <div
                          key={c.character_id}
                          css={css`
                            width: 30px;
                            height: 30px;

                            img {
                              width: 100%;
                              height: 100%;
                              border-radius: 50%;
                            }
                          `}
                        >
                          <img src={c.character_image} alt='character' />
                        </div>
                      ))}
                    </div>
                  </DefaultButton>
                ) : (
                  <DefaultButton
                    onClick={() => setStep('SetAiChatbot')}
                    colorType='black'
                  >
                    Set Ai chatbot
                  </DefaultButton>
                )}
              </S.ButtonWrapper>
            </FlexStack>
          </FlexStack>

          <S.ButtonWrapper>
            <DefaultButton
              onClick={handleGenerateClick}
              disabled={isGenerateDisabled}
            >
              Generate
            </DefaultButton>
          </S.ButtonWrapper>
        </S.Wrapper>
      </S.Container>

      <BottomSheetContainer
        isOpen={passwordSheetOpen}
        onClose={handlePasswordSheetClose}
      >
        <Inner
          title={'Private'}
          desc={'Create a password to keep your private chat secure'}
          placeholder={'Password'}
          text={password}
          setText={setPassword}
          disabled={!password}
          onClick={handlePrivateDoneClick}
        />
      </BottomSheetContainer>
    </>
  );
}
